import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { usePublicOrder } from "../context/PublicOrderContext";

const OrderSuccess = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { slug } = useParams();
  const { resetSession } = usePublicOrder();

  useEffect(() => {
    resetSession();
  }, []);

  if (!state?.orderId) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600">Invalid order access.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 px-6">
      <div className="bg-white p-8 rounded-2xl shadow-xl text-center max-w-md w-full">
        <div className="text-5xl mb-4">✅</div>

        <h2 className="text-2xl font-bold text-green-600 mb-4">
          Order Placed Successfully!
        </h2>

        {/* Order Number */}
        <p className="text-lg font-semibold mb-2">
          🧾 Order No: #{state.orderNumber}
        </p>

        {/* Order Type Info */}
        {state.orderType === "DINE_IN" && (
          <div className="mb-4 text-gray-700">
            <p className="font-semibold text-lg">📍 {state.floorName}</p>

            <p>{state.sectionType === "ROOM" ? "🛏 Room" : "🪑 Table"}:</p>

            <p className="font-semibold">
              {state.sectionName} - {state.unitNumber}
            </p>

            {state.roomType && state.roomType !== "NA" && (
              <p className="text-sm text-gray-500">
                {state.roomType === "AC" ? "❄️ AC" : "🌤 Non-AC"}
              </p>
            )}
          </div>
        )}

        {state.orderType === "DIRECT" && (
          <p className="text-lg font-semibold mb-4">🛍 Parcel Order</p>
        )}

        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate(`/bill/${state.orderId}`)}
            className="w-full bg-gradient-to-r from-pink-500 via-purple-650 to-indigo-650 hover:opacity-90 text-white py-3.5 rounded-xl font-black text-sm uppercase tracking-wider transition shadow-md flex items-center justify-center gap-2"
          >
            🧾 View Bill, Pay & Play 🎮
          </button>

          <button
            onClick={() => navigate(`/r/${slug}`)}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-xl font-semibold transition border border-gray-200"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
